import { useNavigate } from "react-router-dom";
import playground from "../../assets/playground-img.webp";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import CustomButton from "../common/CustomBtn";
import { IoGameControllerOutline } from "react-icons/io5";
import { MdOutlineSentimentSatisfiedAlt } from "react-icons/md";
import { CiDumbbell } from "react-icons/ci";
import { RiTeamLine } from "react-icons/ri";
import CountUp from "react-countup";
import { useTranslation } from "react-i18next";

const fadeInUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 1, ease: "easeOut" } },
};

export const AboutUs = () => {
  const { t } = useTranslation("home");
  const ref = useRef(null);
  const navigate = useNavigate();
  const isInView = useInView(ref, { margin: "-100px" });

  return (
    <section className="w-full h-full px-[5%] bg-[#F2F6F7]">
      <div
        ref={ref}
        className="flex flex-col-reverse justify-between gap-16 py-16 text-black md:gap-8 maxContainer md:flex-row md:py-24"
      >
        <motion.div
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          transition={{ duration: 0.3 }}
          variants={fadeInUp}
          className="relative md:w-[45%] md:max-w-[512px]"
        >
          <motion.img
            src={playground}
            alt="playground-img"
            className="object-cover w-full h-full shadow-lg"
            initial="hidden"
            animate={isInView ? "visible" : "hidden"}
            transition={{ duration: 0.3 }}
            variants={fadeInUp}
          />

          <div
            ref={ref}
            className="absolute -bottom-12 -right-2 sm:-bottom-5 sm:-right-8 xl:-right-12 w-full max-w-[197px] sm:max-w-[259px] bg-tertiary p-2 sm:p-5 rounded-2xl text-white text-[14px]"
          >
            <div className="flex flex-col items-center gap-1 py-2 ss:py-5 border-b border-b-[#eeeeee52] ">
              <h4 className="text-sm font-semibold ss:text-md lg:text-lg">
                <CountUp start={0} end={630} duration={5} />+
              </h4>
              <p className="font-medium text-center text-[#000000d7]">
                {t("summaryHighlight1")}
              </p>
            </div>
            <div className="flex flex-col items-center gap-1 py-2 ss:py-5 border-b border-b-[#eeeeee52]">
              <h4 className="text-sm font-semibold ss:text-md md:text-lg">
                <CountUp start={0} end={95} duration={6} />
              </h4>
              <p className="font-medium text-center text-[#000000d7]">
                {t("summaryHighlight2")}
              </p>
            </div>
            <div className="flex flex-col items-center gap-1 py-2 ss:py-5">
              <h4 className="text-sm font-semibold ss:text-md md:text-lg">
                <CountUp start={0} end={15} duration={7} />
                K+
              </h4>
              <p className="font-medium text-center text-[#000000d7]">
                {t("summaryHighlight3")}
              </p>
            </div>
          </div>
        </motion.div>

        <div className="md:w-[47%] xl:w-1/2">
          <span className="font-light text-tertiary">
            {t("summarySubHeading")}
          </span>

          <h2 className="mt-2 mb-5 font-bold leading-tight text-[28px] ss:text-md md:text-lg md:max-w-[512px]">
            {t("summaryHeading")}
          </h2>

          <p className="mb-5 text-base ">{t("summaryDesc")}</p>

          <div className="grid items-center justify-center grid-cols-2 gap-8 mb-12 text-white">
            <div className="flex flex-col gap-8">
              <div className="flex flex-col items-center gap-5 xs:flex-row">
                <div className="flex items-center justify-center w-10 h-10 rounded-full bg-tertiary">
                  <RiTeamLine fontSize="1.25rem" />
                </div>
                <h6 className="text-[14px] ss:text-base text-black text-center font-medium">
                  {t("summaryItem1")}
                </h6>
              </div>

              <div className="flex flex-col items-center gap-5 xs:flex-row">
                <div className="flex items-center justify-center w-10 h-10 rounded-full bg-tertiary">
                  <IoGameControllerOutline fontSize="1.25rem" />
                </div>
                <h6 className="text-[14px] ss:text-base text-center text-black font-medium">
                  {t("summaryItem3")}
                </h6>
              </div>
            </div>

            <div className="flex flex-col gap-8">
              <div className="flex flex-col items-center gap-5 xs:flex-row">
                <div className="flex items-center justify-center w-10 h-10 rounded-full bg-tertiary">
                  <MdOutlineSentimentSatisfiedAlt fontSize="1.25rem" />
                </div>
                <h6 className="text-black font-medium text-[14px] ss:text-base text-center">
                  {t("summaryItem2")}
                </h6>
              </div>

              <div className="flex flex-col items-center gap-5 xs:flex-row">
                <div className="flex items-center justify-center w-10 h-10 rounded-full bg-tertiary">
                  <CiDumbbell fontSize="1.25rem" />
                </div>
                <h6 className="text-black font-medium text-[14px] ss:text-base text-center">
                  {t("summaryItem4")}
                </h6>
              </div>
            </div>
          </div>

          <div className="flex justify-center w-full">
            <CustomButton
              color="primary"
              onClick={() => navigate("/zaidimu-aiksteles")}
            >
              {t("summaryBtnText")}
            </CustomButton>
          </div>
        </div>
      </div>
    </section>
  );
};
